module.exports = __webpack_public_path__ + "img/no-eduhouse-internal.daa3ee9f.png";